import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { FollowerChatComponent } from 'src/app/shared/components/follower-chat/follower-chat.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-customers-view-details',
  templateUrl: './customers-view-details.component.html',
  styleUrls: ['./customers-view-details.component.scss']
})
export class CustomersViewDetailsComponent implements OnInit {
apisub:Subscription
  constructor(private _apiService:ApiService,@Inject(MAT_DIALOG_DATA) public parentdata:any, private loaderservice: LoaderServiceService, private _modelRef:MatDialog) {

    this.apisub = this._apiService.apiResult.subscribe(resData =>{
      if (resData.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID) {
        if (this.isFromThis) {
          this.isFromThis = false;
          this.previousChatHash = null;
          // this.chatThreads = []
          if (resData.result) {
            resData.result.forEach((element: any) => {
              if(element.senderInfo && element.receiverInfo){
                if (element.senderInfo && typeof element.senderInfo == "string") {
                  element.senderInfo = JSON.parse(element.senderInfo);
                }
                if (
                  element.receiverInfo &&
                  typeof element.receiverInfo == "string"
                ) {
                  element.receiverInfo = JSON.parse(element.receiverInfo);
                }
                if (
                  (element.senderInfo.hash_id == this.senderHashId &&
                    element.receiverInfo.hash_id == this.receiverHashId &&
                    element.entity_public_hash_id ==
                      localStorage.getItem(
                        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
                      )) ||
                  (element.senderInfo.hash_id == this.receiverHashId &&
                    element.receiverInfo.hash_id == this.senderHashId &&
                    element.entity_public_hash_id ==
                      localStorage.getItem(
                        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
                      ))
                ) {
                  this.previousChatHash = element.hash_id;
                }
              
              }
            });
            console.log(this.previousChatHash);
          }
          this.loaderservice.showLoader = false;
          // let data={
          //   title: this.selectedFollowerName,
          //     ref: this.dialog,
          //     previousChatHash: this.previousChatHash,
          //     followerImage: this.selectedFollowerImg,
          //     folowerProfileHash: this.selectedFollowerProfileHash, //
          // }
          // this.dialogService.openFullScreenDialog(FollowerChatComponent, data);


          this._modelRef.open(FollowerChatComponent, {
                    width: "500px",
                    panelClass: 'custom-dialog-container',
                    data: {
                      title: this.selectedFollowerName,
                        ref: this._modelRef,
                        previousChatHash: this.previousChatHash,
                        followerImage: this.selectedFollowerImg,
                        folowerProfileHash: this.selectedFollowerProfileHash, //
                    }
                  });
        }
      }
    })

   }

  ngOnInit(): void {
    
  }

  selectedFollowerName: any;
  selectedFollowerImg: any;
  selectedFollowerProfileHash: any;
  previousChatHash: any = null;
  senderHashId: any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH);
  receiverHashId: any;
  isFromThis: boolean = false;
  openMessages(rowvalue: any) {
    this.isFromThis = true;
    this.selectedFollowerName = rowvalue.name;
    this.selectedFollowerImg = rowvalue.image_thumb_url;
    this.selectedFollowerProfileHash = rowvalue.profile_hash_id;
    this.receiverHashId = rowvalue.profile_hash_id;
    this.loaderservice.showLoader = true;
    this._apiService.getMessagesByID();
  }

}
